import { Body_add_your_food_api_v1_meals_your_food_post } from "@/clients/models/Body_add_your_food_api_v1_meals_your_food_post";
import { MealsService } from "@/clients/services/MealsService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useMutation } from "@tanstack/react-query";

export const useAddYourFood = () => {
  const { mutate, mutateAsync, isPending, isError, error } = useMutation({
    mutationKey: [QueryKeys.YOUR_FOOD],
    mutationFn: async (formData: Body_add_your_food_api_v1_meals_your_food_post) => {
      const user = guardGetUserFromLocalStorage();
      const { data } = await MealsService.addYourFoodApiV1MealsYourFoodPost(
        user.id,
        formData as Body_add_your_food_api_v1_meals_your_food_post,
      );
      return data;
    },
  });

  return {
    addYourFood: mutate,
    addYourFoodAsync: mutateAsync,
    isLoading: isPending,
    isError,
    error,
  };
};
